{{ data.errorMessage }}
<a id="bug-report-snackbar-report-button" mat-button
   href="{{ data.bugReportUrl }}" target="_blank">
    Nahlásit chybu
</a>
<button id="bug-report-snackbar-close-button" mat-button (click)="snackBarRef.dismissWithAction()">
    Zavřít
</button>
